(function() {
	'use strict';
	var $ = avm.require('cash'),
	$tab = $('.nav-link'),
	$tabContent = $('.tab-pane'),
	unserializedUrl = avm.require('avast.url.unserialize')(),
	tabSwitch = unserializedUrl.tab, //parameter value
	tabToActive = tabSwitch ? $tab.eq(tabSwitch- 1) : null, // object of specific tab
	contentToActive = tabSwitch ? $tabContent.eq(tabSwitch- 1) : null; // object of specific tab content


	// Display active tab from url param
	if (tabToActive) {
		$tab.removeClass('show active');
		$tabContent.removeClass('show active');
		tabToActive.addClass('show active');
		contentToActive.addClass('show active');
	}

})();
